import config from '../../app-config';

export function isProductionEnv() {
  return config.deployedEnvironment === 'production';
}
